import Logger from '../logger';

class ReserveButtonChecker extends HTMLElement {
  #NAME = 'ReserveButtonChecker'

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    const origSubmitBtn = document.querySelector('.product-info__block--desktop .product-info__add-button button[type="submit"]');
    /* document.addEventListener('actionarea:button:updated', (e) => console.log(e)); */
    //
    if (origSubmitBtn) {
      const mutationCallback = (mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            if (!origSubmitBtn.clientHeight) {
              Logger.info(`${this.#NAME} > mutation > style > display: none`);
              const mobileSubmitBtn = document.querySelector('.cpp-reserved-add_btn');
              const newBtn = mobileSubmitBtn.cloneNode(true);
              /* const regex = new RegExp('jQuery.*');
              //
              for (const key in mobileSubmitBtn) {
                if (regex.test(key)) {
                  const handler = mobileSubmitBtn[key].events.click[0].handler;
                  console.dir(handler);
                  if (handler) newBtn.addEventListener('click', handler);
                  break;
                }
              } */
              newBtn.addEventListener('click', () => mobileSubmitBtn.click());
              origSubmitBtn.parentNode.insertBefore(newBtn, origSubmitBtn);
              document.dispatchEvent(new Event('actionarea:button:updated'));
            }
            
          }
        }
      };
      this.observer = new MutationObserver(mutationCallback);
      this.observer.observe(origSubmitBtn, { attributes: true });
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

customElements.define('reserve-button-checker', ReserveButtonChecker);

